import React from 'react';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { SVGS } from '../../../../assets';
import { CommonButton } from '../../../../components';
import { TouchableOpacity } from '../../../../common';
import {
  APP_TYPE,
  clearExtraDetails,
  dispatch,
  getAppType,
  getExtraDetails,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { useNavigate } from 'react-router-dom';
import { FIELD_OPS_ROUTES, SELLER_WEBAPP_ROUTES } from '../../../../constants';
import './customer-success-modal.scss';

interface CustomerSuccessModalProps {
  open: boolean;
  onClose: () => void;
}
export const CustomerSuccessModal: React.FC<CustomerSuccessModalProps> = ({
  open,
  onClose,
}) => {
  const appType = useAppSelector(getAppType);
  const navigate = useNavigate();
  const customerDetails = useAppSelector(getExtraDetails);

  const handleClose = () => {
    dispatch(clearExtraDetails());
    onClose?.();
  };

  const onViewCustomer = () => {
    if (customerDetails?.customerId) {
      const navigateToRoute =
        appType === APP_TYPE.FIELDS_OPS
          ? FIELD_OPS_ROUTES.CUSTOMER_DETAILS
          : SELLER_WEBAPP_ROUTES.MANAGE_CUSTOMERS_DETAILS;

      navigate(
        `${navigateToRoute?.replace(':customerId', customerDetails?.customerId)}`
      );
    }
  };

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={handleClose}
      onOpen={() => {}}
      PaperProps={{
        className: 'success-modal__drawer',
      }}
      disableSwipeToOpen
    >
      <Box className="success-modal__container">
        <div className="success-modal__view">
          <img src={SVGS.SuccesIcon} />
          <div className="success-modal__view-text font-semibold">
            {`${customerDetails?.customerName || customerDetails?.companyName} has been added as a customer${appType === APP_TYPE.FIELDS_OPS ? ' and assigned to your today’s beat plan.' : '.'}`}
          </div>
        </div>
        <CommonButton
          text={`View Customer`}
          onPress={onViewCustomer}
          buttonStyle={'success-modal__view-btn'}
        />

        <TouchableOpacity
          onPress={handleClose}
          className="success-modal__done-btn"
        >
          <div className="success-modal__done-btn-text font-semibold">
            {'Done'}
          </div>
        </TouchableOpacity>
      </Box>
    </SwipeableDrawer>
  );
};
